"use client";

import React from "react";
import { Check } from "lucide-react";
import { motion } from "framer-motion";
const points = ["20+ years industry experience", "NASC accredited", "CHAS accredited", "Commercial & residential scaffolding"];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.06,
      delayChildren: 0.05
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 12
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.35,
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
};
export default function WhyBmf() {
  return <section id="whybmf" data-nav="light" className="bg-background text-foreground border-t border-border py-10 md:py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: "-20px"
      }} className="flex flex-col items-center">
          <motion.h2 variants={itemVariants} className="text-xl sm:text-2xl font-bold tracking-tight text-foreground text-center mb-6 md:mb-8">
            Why BMF
          </motion.h2>

          <motion.div variants={containerVariants} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 w-full">
            {points.map((point, i) => <motion.div key={i} data-index={i} variants={itemVariants} className="flex items-center gap-3 rounded-md bg-card/60 border border-border/80 px-4 py-3 shadow-2xs">
                <div className="flex size-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <Check className="size-3.5 stroke-[2.5]" aria-hidden="true" />
                </div>
                <span className="text-sm font-medium text-foreground tracking-tight">
                  {point}
                </span>
              </motion.div>)}
          </motion.div>
        </motion.div>
      </div>
    </section>;
}